import { render, staticRenderFns } from "./contentCourseExamMultiChoice.vue?vue&type=template&id=38a2790d&"
import script from "./contentCourseExamMultiChoice.vue?vue&type=script&lang=js&"
export * from "./contentCourseExamMultiChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports